"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var axios_1 = require("axios");
var HomeTemplate = /** @class */ (function (_super) {
    __extends(HomeTemplate, _super);
    function HomeTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            data: props.data
        };
        return _this;
    }
    HomeTemplate.prototype.componentDidMount = function () {
        var _this = this;
        axios_1.default.get("/?view=json").then(function (response) {
            var data = _this.state.data;
            var json = JSON.parse(response.data.replace(/(<([^>]+)>)/gi, "").replace(",", ""));
            data.sections = json;
            _this.setState({ data: data });
        });
    };
    HomeTemplate.prototype.render = function () {
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(next_components_1.ShopifyNext.Components.DynamicSections, __assign({}, this.props, { data: this.state.data }))));
    };
    return HomeTemplate;
}(React.Component));
exports.HomeTemplate = HomeTemplate;
